/**
 * Codes e-mail Standard autorisés dans ``email_list`` (valeurs exactes API).
 * Aligné sur EmailListItemEnum côté backend.
 */
export const EMAIL_LIST_ITEMS = [
    {
        value: '01-confirmation-souscription-se_jour',
        label: '01 — Confirmation souscription séjour',
    },
    {
        value: '02-declenchement-journalier-se_jour',
        label: '02 — Déclenchement journalier séjour',
    },
    {
        value: '03-non-declenchement-journalier-séjour',
        label: '03 — Non-déclenchement journalier séjour',
    },
    {
        value: '04-recap-sejour-declenche',
        label: '04 — Récap séjour déclenché',
    },
    {
        value: '05-recap-sejour-non-declenche',
        label: '05 — Récap séjour non déclenché',
    },
    {
        value: '06-recap-sejour-modifie',
        label: '06 — Récap séjour modifié',
    },
    {
        value: '07-garantie-annulee',
        label: '07 — Garantie annulée',
    },
    {
        value: '08-relance-rib',
        label: '08 — Relance RIB',
    },
    {
        value: '09-confirmation-reception-rib',
        label: '09 — Confirmation réception RIB',
    },
    {
        value: '10-virement-effectue',
        label: '10 — Virement effectué',
    },
];

export const EMAIL_LIST_ITEM_VALUES = EMAIL_LIST_ITEMS.map((item) => item.value);

export const EMAIL_LIST_ITEM_LABELS = EMAIL_LIST_ITEMS.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
}, {});

export const getEmailListItemLabel = (value) => (
    EMAIL_LIST_ITEM_LABELS[value] || value || '—'
);

export const toggleEmailListItem = (currentList, value) => {
    const list = Array.isArray(currentList) ? currentList : [];
    if (list.includes(value)) {
        return list.filter((item) => item !== value);
    }
    return [...list, value];
};
